/**
 * @desc 竞拍核心模块
 */
import { auctionAxios, auctionAxiosDirect } from '../httpInstance';
// 当月发拍数统计
export function getAuctionCount() {
    return auctionAxios({
        method: 'POST',
        url: 'auctionCount',
    });
}
/**
 * 拍卖管理-场次打印
 * */
// --------------------- start -------------------/
// 1.获取场次详情
export const getScenePrinting = (data) => {
    return auctionAxios({
        url: 'getScenePrinting',
        method: 'POST',
        data,
    });
};
/**
 * 系统管理-拍卖规则
 * */
// --------------------- start -------------------/
// 1.佣金设置
// 获取佣金列表
export function getBrokerageInfo(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'getBrokerageInfo',
        data: payload,
    });
}
// 获取车辆类型列表
export function getCarTypeList(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'getCarTypeList',
        data: payload,
    });
}
// 新建
export function saveBrokerage(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'editBrokerage',
        data: JSON.stringify(payload),
        headers: {
            post: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        },
    });
}
// 佣金列表
export function getBrokerageList() {
    return auctionAxios({
        method: 'POST',
        url: 'getBrokerageList',
    });
}
// 2.服务费设置
// 获取服务费列表
export function getCommissionInfo(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'getCommissionInfo',
        data: payload,
    });
}
// 获取服务费修改记录列表
export function getCommissionRecordPage(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'getCommissionRecordPage',
        data: payload,
    });
}
// 获取佣金修改记录列表
export function getBrokerageRecordPage(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'getBrokerageRecordPage',
        data: payload,
    });
}
// 编辑服务费
export function editCommission(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'editCommission',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
    });
}
// 服务费列表-new
export function getCommissionList() {
    return auctionAxios({
        method: 'POST',
        url: 'getCommissionList',
    });
}
// 3.拍卖地址设置
// 分页查询信息
export function queryRoundAddress(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'queryRoundAddress',
        data: payload,
    });
}
// 新建/更新
export function editRoundAddress(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'editRoundAddress',
        data: payload,
    });
}
// 删除
export function delRoundAddress(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'delRoundAddress',
        data: payload,
    });
}
// 4.文案设置
// 分页查询信息
export function queryFrontContent(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'queryFrontContent',
        data: payload,
    });
}
// 更新
export function updateFrontContent(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'updateFrontContent',
        data: payload,
    });
}
// 获取佣金百分比
export function getDefaultCommission(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'getDefaultCommission',
        data: payload,
    });
}
// --------------------- end -------------------/
/** 场次 */
// desc 创建场次
export const createSession = (data) => {
    return auctionAxios({
        url: 'createSession',
        method: 'POST',
        data,
        timeout: 30000,
    });
};
// desc 更新场次规则【佣金，服务费】
export const updateRoundRule = (data) => {
    return auctionAxios({
        url: 'updateRoundRule',
        method: 'POST',
        data,
        timeout: 30000,
    });
};
// desc 场次保存
export const saveSession = (data) => {
    return auctionAxios({
        url: 'save',
        method: 'POST',
        timeout: 30000,
        data,
    });
};
// desc 场次发拍
export const initiateAuction = (data) => {
    return auctionAxios({
        url: 'send',
        method: 'POST',
        data,
    });
};
// desc 修改拍品信息
export const editGoods = (data) => {
    return auctionAxios({
        url: 'editGoods',
        method: 'POST',
        data,
    });
};
// desc 排序车辆
export const editSerialNumber = (data) => {
    return auctionAxios({
        url: 'editSerialNumber',
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        data: JSON.stringify(data),
    });
};
// desc 移除车辆
export const removeGoods = (data) => {
    return auctionAxios({
        url: 'removeGoods',
        method: 'POST',
        data,
    });
};
// desc 添加车辆
export const addGoodsList = (data) => {
    return auctionAxios({
        url: 'addGoodsList',
        method: 'POST',
        data,
        timeout: 30000,
    });
};
// desc 移动车辆
export const moveGoods = (data) => {
    return auctionAxios({
        url: 'moveGoods',
        method: 'POST',
        data,
    });
};
// desc 获取场次详情
export const getSessionDetails = (data) => {
    return auctionAxios({
        url: 'getSessionDetails',
        method: 'POST',
        data,
    });
};
// desc 获取价签列表详情
export const getPriceDetails = (data) => {
    return auctionAxios({
        url: 'getByRoundId',
        method: 'POST',
        data,
    });
};
// desc 获取场次二维码
export const getMiniCode = (data) => {
    return auctionAxios({
        url: 'getMiniCode',
        method: 'POST',
        data,
    });
};
// desc 获取场次下拍品
export const queryByRoundId = (data) => {
    return auctionAxios({
        url: 'queryByRoundId',
        method: 'POST',
        data,
        timeout: 30000,
        ['hideLoading']: true,
    });
};
// desc 场次拍品信息
export const getGoodsDetails = (data) => {
    return auctionAxios({
        url: 'getGoodsDetails',
        method: 'GET',
        data,
    });
};
// desc 获取场次地址
export const getSessionAddress = () => {
    return auctionAxios({
        url: 'querySessionPosition',
    });
};
// desc 查询场次是否开启下架（暗拍竞拍中）
export const selectTakeOff = (params) => {
    return auctionAxios({
        url: 'selectTakeOff',
        params,
    });
};
// desc 查看当前竞拍单最高价是否超过保留价
export const selectHigherBasePrice = (auctionId) => {
    return auctionAxios({
        url: 'selectHigherBasePrice',
        data: {
            auctionId,
        },
        method: 'POST',
    });
};
// desc 是否正在拍最后一辆车
export const isAuctionLast = (roundId) => {
    return auctionAxios({
        url: 'isAuctionLast',
        data: {
            roundId,
        },
        method: 'POST',
    });
};
// desc 暗拍场次结束时间是否大于等于2分钟(1-是，0-不是）
export const isTwoMinLeft = (roundId) => {
    return auctionAxios({
        url: 'isTwoMinLeft',
        data: {
            roundId,
        },
        method: 'POST',
    });
};
// desc 暗拍竞拍中下架车辆（流拍）
export const setAuctionFailed = (auctionId) => {
    return auctionAxios({
        url: 'setAuctionFailed',
        data: {
            auctionId,
        },
        method: 'POST',
    });
};
/** 加价师*/
// desc 获取加价按钮配置
export const getCustomPriceButton = (data) => {
    return auctionAxios({
        url: 'getCustomPriceButton',
        params: data,
        ['hideLoading']: true,
    });
};
// desc 获取正在拍卖中的拍卖信息
export const getAuctionInfo = (data) => {
    return auctionAxios({
        url: 'getAuctionInfo',
        method: 'POST',
        data,
        ['hideLoading']: true,
    });
};
// desc 获取下一辆车数据
export const getNextAuctionInfo = (data) => {
    return auctionAxios({
        url: 'getNextAuctionInfo',
        method: 'POST',
        data,
        ['hideLoading']: true,
    });
};
// desc 校验号牌是否存在
export const existFlapper = (data) => {
    return auctionAxios({
        url: 'existFlapper',
        method: 'POST',
        data,
    });
};
// desc 获取上辆车拍卖结果
export const getAuctionResult = (params) => {
    return auctionAxios({
        url: 'getAuctionResult',
        method: 'GET',
        params,
    });
};
// desc 取消操作上辆车拍卖结果
export const cancelPerAuctionResult = (data) => {
    return auctionAxios({
        url: 'cancelPerAuctionResult',
        method: 'POST',
        data,
    });
};
// desc 成交后补充号牌
export const addFlapperInfo = (data) => {
    return auctionAxios({
        url: 'addFlapperInfo',
        method: 'POST',
        data,
    });
};
// desc 应价锁定/解锁
export const biddingOperation = (data) => {
    return auctionAxios({
        url: 'biddingOperation',
        method: 'POST',
        data,
    });
};
// desc 加价/应价
export const bid = (data) => {
    return auctionAxios({
        url: 'bid',
        method: 'POST',
        data,
    });
};
// desc 车辆状态列表-拍卖状态列表
export const getAuctionStateList = (data) => {
    return auctionAxios({
        url: 'getAuctionStateList',
        method: 'POST',
        data,
    });
};
// desc 出价记录
export const bidRecord = (data) => {
    return auctionAxios({
        url: 'bidRecord',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        ['hideLoading']: true,
        data: JSON.stringify(data),
    });
};
// desc 佣金修改记录
export const getBrokerageRecordList = (data) => {
    return auctionAxios({
        url: 'getBrokerageRecordList',
        method: 'POST',
        data,
    });
};
// desc 车辆状态查询-拍卖状态-待成交
export const getAuctionTradeList = (data) => {
    return auctionAxios({
        url: 'getAuctionTradeList',
        method: 'POST',
        data,
    });
};
/**
 * 拍卖管理--场次管理
 * */
// 场次分页查询
export const queryPageAuctionRound = (data) => {
    return auctionAxios({
        method: 'POST',
        url: 'queryPageAuctionRound',
        data,
    });
};
// desc 待成交车辆列表成交/流拍操作
export const dealAuction = (data) => {
    return auctionAxios({
        url: 'dealAuction',
        method: 'POST',
        data,
    });
};
// 场次撤销
export const cancelPageAuctionRound = (data) => {
    return auctionAxios({
        url: 'cancelPageAuctionRound',
        method: 'POST',
        data,
        timeout: 30000,
    });
};
// 待发拍 场次删除
export const deletePageAuctionRound = (data) => {
    return auctionAxios({
        url: 'deletePageAuctionRound',
        method: 'POST',
        data,
    });
};
// 导出
export const globalExport = (params) => {
    return auctionAxiosDirect({
        url: 'auctionExport',
        method: 'POST',
        responseType: 'blob',
        data: params,
    });
};
// 场次导出排序
export const auctionExportSort = (data) => {
    auctionAxiosDirect({
        url: 'auctionExportSort',
        method: 'POST',
        responseType: 'blob',
        data,
    }).then((res) => {
        const content = res;
        const elink = document.createElement('a');
        const currentDay = new Date();
        const fileName = `${currentDay.getFullYear()}${currentDay.getMonth() + 1}${currentDay.getDate()}`;
        elink.download = `${fileName}.xls`; // 设置下载文件名
        elink.style.display = 'none';
        const blob = new Blob([content]);
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
    });
};
// 场次导入排序
export const auctionLeadInSort = (data) => {
    return auctionAxiosDirect({
        url: '/auctioningGoodsApi/importSort.json',
        method: 'POST',
        data,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        timeout: 20000,
    });
};
// 拍卖师详情接口
export const auctioneerDetail = (params) => {
    return auctionAxios({
        url: 'auctioneerDetail',
        method: 'POST',
        params,
        ['hideLoading']: true,
    });
};
// 拍卖师 模拟、正式拍卖接口
export const startAuction = (params) => {
    return auctionAxios({
        url: 'startAuction',
        method: 'POST',
        params,
    });
};
// 拍卖师 暂停拍卖接口
export const stopAuction = (params) => {
    return auctionAxios({
        url: 'stopAuction',
        method: 'POST',
        params,
    });
};
// 拍卖师 继续拍卖接口
export const goOnAuction = (params) => {
    return auctionAxios({
        url: 'goOnAuction',
        method: 'POST',
        params,
    });
};
// 拍卖师 结束拍卖接口
export const endAuction = (params) => {
    return auctionAxios({
        url: 'endAuction',
        method: 'POST',
        params,
    });
};
// 拍卖师 立即结束竞拍接口
export const auctionEnd = (data) => {
    return auctionAxios({
        url: 'auctionEnd',
        method: 'POST',
        data,
    });
};
// 拍卖师 开启倒计时接口
export const startCountDown = (params) => {
    return auctionAxios({
        url: 'startCountDown',
        method: 'POST',
        params,
    });
};
// 拍卖师 倒计时继续接口
export const continueCountDown = (params) => {
    return auctionAxios({
        url: 'continueCountDown',
        method: 'POST',
        params,
    });
};
// 拍卖师 倒计时暂停接口
export const pauseCountDown = (params) => {
    return auctionAxios({
        url: 'pauseCountDown',
        method: 'POST',
        params,
    });
};
// 拍卖师 成交接口
export const clinch = (params) => {
    return auctionAxios({
        url: 'clinch',
        method: 'POST',
        params,
    });
};
// 拍卖师 流拍接口
export const failAuction = (params) => {
    return auctionAxios({
        url: 'failAuction',
        method: 'POST',
        params,
    });
};
// 拍卖师 待成交接口
export const pendingTransaction = (params) => {
    return auctionAxios({
        url: 'pendingTransaction',
        method: 'POST',
        params,
    });
};
// 拍卖师 询价接口
export const inquiryPrice = (params) => {
    return auctionAxios({
        url: 'inquiryPrice',
        method: 'POST',
        params,
    });
};
/**
 * 拍卖管理-拍卖中车辆
 * */
//
export const queryPageAuctioningGoods = (data) => {
    return auctionAxios({
        method: 'POST',
        url: 'queryPageAuctioningGoods',
        data,
    });
};
// 下架
export const takeOffAuctioningGoods = (data) => {
    return auctionAxios({
        method: 'POST',
        url: 'takeOffAuctioningGoods',
        data,
    });
};
// 大屏 详情接口
export const getScreenDetail = (params) => {
    return auctionAxios({
        url: 'getScreenDetail',
        method: 'POST',
        params,
        ['hideLoading']: true,
        ['cancelRepeat']: true,
    });
};
// 大屏 是否结束接口
export const hasEndOfTheAuction = (params) => {
    return auctionAxios({
        url: 'hasEndOfTheAuction',
        method: 'POST',
        data: JSON.stringify(params),
        headers: {
            post: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        },
        ['hideLoading']: true,
        ['cancelRepeat']: true,
    });
};
// 待成交拍卖单添加买家信息
export const addBuyerInfo = (params) => {
    return auctionAxios({
        url: 'addBuyerInfo',
        method: 'POST',
        params,
    });
};
// 玩法规则列表
export const getAuctionPlayRuleList = (payload) => {
    return auctionAxios({
        url: 'getAuctionPlayRuleList',
        method: 'POST',
        data: payload,
    });
};
// 玩法规则
export const getAuctionPlayRule = (payload) => {
    return auctionAxios({
        url: 'getAuctionPlayRule',
        method: 'get',
        params: payload,
    });
};
// 根据Id获取玩法规则
export const getAuctionPlayRuleById = (data) => {
    return auctionAxios({
        url: 'getAuctionPlayRuleById',
        method: 'POST',
        data,
    });
};
// 保存玩法规则
export const saveOrUpdatePlayRule = (data) => {
    return auctionAxios({
        url: 'saveOrUpdatePlayRule',
        method: 'POST',
        data,
    });
};
// 分页查询玩法规则
export const getPlayRulesByPage = (payload) => {
    return auctionAxios({
        url: 'getPlayRulesByPage',
        method: 'POST',
        data: payload,
    });
};
// 查询保留价提醒设置
export const getReserveTipsRule = (payload) => {
    return auctionAxios({
        url: 'getCommonRule',
        method: 'POST',
        data: payload,
    });
};
// 保存保留价提醒设置
export const saveReserveTipsRule = (payload) => {
    return auctionAxios({
        url: 'saveCommonRule',
        method: 'POST',
        data: JSON.stringify(payload),
        headers: {
            post: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        },
    });
};
// 获取佣金配置详情
export const getCommissionRecord = (params) => {
    return auctionAxios({
        url: 'getCommissionRecord',
        method: 'get',
        params,
    });
};
// 获取服务费配置详情
export const getServiceRecord = (params) => {
    return auctionAxios({
        url: 'getServiceRecord',
        method: 'get',
        params,
    });
};
/**
 * desc 竞拍管理
 * */
// 获取场次信息
export const getBidSession = (data) => {
    return auctionAxios({
        url: 'getBidSession',
        method: 'POST',
        data,
    });
};
// 竞拍管理详情页-车辆信息列表
export const roundMonitorList = (data) => {
    return auctionAxios({
        url: 'roundMonitorList',
        method: 'POST',
        data,
    });
};
// 竞拍管理详情页-数据概览
export const roundMonitorInfo = (params) => {
    return auctionAxios({
        url: 'roundMonitorInfo',
        method: 'get',
        params,
    });
};
// 获取保证金
export const getAuctionBaseInfo = (data) => {
    return auctionAxios({
        url: 'getAuctionBaseInfo',
        method: 'POST',
        data,
    });
};
// 删除佣金
export const delBrokerageRecord = (data) => {
    return auctionAxios({
        url: 'delBrokerageRecord',
        method: 'POST',
        data,
    });
};
// 设置默认佣金
export const brokerageSetDefaultTag = (data) => {
    return auctionAxios({
        url: 'brokerageSetDefaultTag',
        method: 'POST',
        data,
    });
};
// 设置默认服务费
export const commissionSetDefaultTag = (data) => {
    return auctionAxios({
        url: 'commissionSetDefaultTag',
        method: 'POST',
        data,
    });
};
// 删除服务费
export const delCommissionRecord = (data) => {
    return auctionAxios({
        url: 'delCommissionRecord',
        method: 'POST',
        data,
    });
};
// 删除玩法规则
export const delAuctionPlayRule = (data) => {
    return auctionAxios({
        url: 'delAuctionPlayRule',
        method: 'POST',
        data,
    });
};
// 设置默认玩法规则
export const setDefaultPlayRule = (data) => {
    return auctionAxios({
        url: 'setDefaultPlayRule',
        method: 'POST',
        data,
    });
};
// 玩法规则修改记录
export const getPlayRulesRecordPage = (data) => {
    return auctionAxios({
        url: 'getPlayRulesRecordPage',
        method: 'POST',
        data,
    });
};
// 拍卖管理-场次数据详情-出价会员 & 本机构出价会员弹窗
export function buyerBidRecord(payload) {
    return auctionAxios({
        method: 'POST',
        url: 'buyerBidRecord',
        data: JSON.stringify(payload),
        headers: {
            post: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        },
    });
}
// 拍卖管理-场次数据详情-头部场次信息
export const auctionRoundDetail = (data) => {
    return auctionAxios({
        url: 'auctionRoundDetail',
        method: 'POST',
        data,
    });
};
// 查询场次状态数量
export const queryRoundStatusNum = (data) => {
    return auctionAxios({
        url: 'queryRoundStatusNum',
        method: 'POST',
        data,
    });
};
// 查询场次监控状态数量
export const roundMonitorTabDataCount = (data) => {
    return auctionAxios({
        url: 'roundMonitorTabDataCount',
        method: 'POST',
        data,
    });
};
/**
 * 车辆管理 竞拍记录
 * @param data
 */
export const getOfferCeneListByGoodsId = (data) => {
    return auctionAxios({
        url: 'queryAuctionRecordPage',
        method: 'POST',
        data,
    });
};
/**
 * 车辆管理 处理 取消报价
 * @param data
 */
export const cancelBid = (data) => {
    return auctionAxios({
        url: 'cancelBid',
        method: 'POST',
        data,
    });
};
/**
 * 车辆管理-实时监控
 * */
// 获取车辆信息
export const getRealtimeCarDetails = (data) => {
    return auctionAxios({
        url: 'getAuctionBaseInfo',
        method: 'POST',
        data,
    });
};
// 获取车辆监控数据
export const auctionRealTimeMonitor = (data) => {
    return auctionAxios({
        url: 'auctionRealTimeMonitor',
        method: 'POST',
        data,
        ['hideLoading']: true,
    });
};
// 获取关注记录
export const queryFocusPage = (data) => {
    return auctionAxios({
        url: 'queryFocusPage',
        method: 'POST',
        data,
    });
};
// 获取浏览记录
export const queryBrowerPage = (data) => {
    return auctionAxios({
        url: 'queryBrowerPage',
        method: 'POST',
        data,
    });
};
